import { Select } from "antd";
import * as React from "react";
import { useEffect } from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectLedgerAll {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectLedgerAll = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectLedgerAll) => {
  const itemList = useStoreState((state) => state.ledger.allLedgerList);

  const itemListFetch = useStoreActions((state) => state.ledger.fetchallLedgerList);

  useEffect(()=>{
    itemListFetch();
  },[])

  const onSelect = (id) => {
    if (itemList) {
      const val = itemList.find((item) => item.ledgerId === id);
      onChange(val?.ledgerId);
    }
  };




  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      allowClear
      placeholder="Select Category"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.ledgerId} value={type.ledgerId}>
            {type.ledgerName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Category</Option>
      )}
    </Select>
  );
};
